import React from 'react'
import SwipeableViews from 'react-swipeable-views'
import { ProductBuilderState } from '../state'
import { connect } from 'react-redux'
import { ProductBuilderStepStartView } from './step-start'
import { ProductBuilderStepParamsView } from './step-params'
import makeStyles from '@material-ui/styles/makeStyles'

const useStyles = makeStyles((theme: any) => ({
    root: {
        marginBottom: theme.spacing(2),
        '& .MuiButton-root': {
            borderRadius: 0,
            '&.MuiButton-containedPrimary:hover': {
                color: theme.palette.primary.contrastText
            },
            '& .MuiSvgIcon-root': {
                marginRight: theme.spacing(1)
            }
        }
    }
}), { name: 'ProductBuilder' })

const productBuilderRoot = (props: ProductBuilderState) => {
    const classes = useStyles(props)
    if (!props.product || !props.productParameters) return <div>Loading...</div>
    return <div className={classes.root}>
        <SwipeableViews index={props.stepIndex} disabled={true}>
            <div className='StepStart'>
                <ProductBuilderStepStartView product={props.product} />
            </div>
            <div className='StepParams'>
                <ProductBuilderStepParamsView  loading={props.loading} />
            </div>
        </SwipeableViews>
    </div>
}

export const ProductBuilderRoot =
    connect((state: any) => state.productBuilderState)(productBuilderRoot)